
import { defineMessages } from 'react-intl'

export default defineMessages({
  unpaid: {
    id: 'containers.CustomerBillingPage.components.InvoiceRow.status.unpaid',
    defaultMessage: 'Unpaid',
  },
  paid: {
    id: 'containers.CustomerBillingPage.components.InvoiceRow.status.paid',
    defaultMessage: 'Paid',
  },
  draft: {
    id: 'containers.CustomerBillingPage.components.InvoiceRow.status.draft',
    defaultMessage: 'Draft',
  },
  creditNote: {
    id: 'containers.CustomerBillingPage.components.InvoiceRow.status.creditNote',
    defaultMessage: 'Credit Note',
  },
  download: {
    id: 'containers.CustomerBillingPage.components.InvoiceRow.download',
    defaultMessage: 'Download PDF',
  },
})
